import { render, staticRenderFns } from "./ProvidersFeed.vue?vue&type=template&id=2b38bfa2&"
import script from "./ProvidersFeed.vue?vue&type=script&lang=ts&"
export * from "./ProvidersFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports